export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './insightsLicenses.service';
import { InsightsLicensesService } from './insightsLicenses.service';
export * from './pricing.service';
import { PricingService } from './pricing.service';
export * from './remoteMaintenanceLicenses.service';
import { RemoteMaintenanceLicensesService } from './remoteMaintenanceLicenses.service';
export const APIS = [AuthenticationService, InsightsLicensesService, PricingService, RemoteMaintenanceLicensesService];
